export const EVENT_LAYOUT = 'EventLayout';

export const EventsRouter = [
  {
    path: '/events',
    name: 'Events',
    component: () => import('@/views/events/Index.vue'),
  },
  {
    path: '/events/:id',
    name: 'ShowEvent',
    component: () => import('@/views/events/Show.vue'),
    meta: {
      layout: EVENT_LAYOUT
    }
  },
  {
    path: '/events/:id/album/:album_id',
    name: 'ShowEventAlbum',
    component: () => import('@/views/events/Show.vue'),
    meta: {
      layout: EVENT_LAYOUT
    }
  },
];
